var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Slide, Snackbar } from "@mui/material";
import { styled } from "@mui/styles";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAlert = styled(Alert)(function (severity) { return ({ '&.MuiAlert-root': { backgroundColor: '#D1FAE5', color: '#065F46', fontSize: '14px' }, '&.MuiAlert-action': { fontSize: '24px', padding: '4px !important', color: '#059669' } }); });
var StyledSnackbar = styled(Snackbar)({ '&.MuiSnackbar-root': { top: '10%' } });
var TransitionRight = function (props) { return /*#__PURE__*/ _jsx(Slide, __assign(__assign({}, props), { direction: "right" })); };
export var SnackbarComponent = function (_a) {
    var open = _a.open, handleClose = _a.handleClose, message = _a.message;
    return /*#__PURE__*/ _jsx(StyledSnackbar, { TransitionComponent: TransitionRight, open: open, autoHideDuration: 10000, anchorOrigin: { vertical: 'top', horizontal: 'center' }, onClose: handleClose, children: /*#__PURE__*/ _jsx(StyledAlert, { onClose: handleClose, severity: "success", sx: { width: '100%' }, icon: /*#__PURE__*/ _jsx(FontAwesomeIcon, { icon: ['fas', 'circle-check'], color: "#34D399", fontSize: '24px' }), children: message }) });
};
